import render from './render'

export default {
  name: 'Panel',

  props: {
    type: String,

    value: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  render
}
